import React from "react";
import { FormattedMessage } from "react-intl";
import {
  type IPhoneNoInputProps,
  PhoneNoInput,
} from "src/shared/forms/inputs/PhoneNoInput";
import { NORTH_AMERICAN_PHONE_REGEX } from "src/shared/forms/inputs/phoneNoValidationRegex";

export interface IContactPhoneNoInputProps extends IPhoneNoInputProps {}

export const ContactPhoneNoInput = ({
  label = <FormattedMessage id="contacts.phone_no" />,
  isRequired = false,
  ...rest
}: IContactPhoneNoInputProps) => (
  <PhoneNoInput
    {...rest}
    label={label}
    isRequired={isRequired}
    maxLength={32}
    phoneRegex={NORTH_AMERICAN_PHONE_REGEX}
  />
);
